export default __webpack_public_path__ + "static/media/82t.64a434f5.jpg";